import React from 'react';

import { Radio, RadioGroup, FormControl, FormLabel, FormHelperText, Sheet } from '@mui/joy';

interface Props {
  label: string;
  name: string;
  value: string | number;
  error?: string;
  onChange: (value: string) => void;
  options: { value: string; label: string; description?: string }[];
  required?: boolean;
}

export const ActionRadioField: React.FC<Props> = ({
  label,
  name,
  value,
  error,
  onChange,
  options,
  required = false
}) => (
  <FormControl className='mb-4' error={!!error} required={required}>
    <FormLabel>{label}</FormLabel>
    <Sheet
      sx={{
        borderRadius: 'md',
        border: '1px solid',
        borderColor: 'neutral.outlinedBorder'
      }}
      variant='outlined'
    >
      <RadioGroup name={name} onChange={(event) => onChange(event.target.value)} value={value}>
        {options.map((option) => (
          <Sheet
            key={option.value}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
              p: 1
            }}
          >
            <Radio label={option.label} value={option.value} />
            {option.description && <FormHelperText sx={{ mt: -1 }}>{option.description}</FormHelperText>}
          </Sheet>
        ))}
      </RadioGroup>
    </Sheet>
    {error && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);
